export {default as randomUniform} from "./src/uniform";
export {default as randomNormal} from "./src/normal";
export {default as randomLogNormal} from "./src/logNormal";
export {default as randomBates} from "./src/bates";
export {default as randomIrwinHall} from "./src/irwinHall";
export {default as randomExponential} from "./src/exponential";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-random/index.js
// module id = 361
// module chunks = 0 1 2 3 4